const shortenStr = (length = 20, str) =>
    str.length <= length ? str : `${str.substring(0, length)}...`;

export default shortenStr;
